import { IS_PROD } from '@webapp/infrastructure/envs'
import { useRunConversationTurnPresenter } from './useRunConversationTurnPresenter'
import { ConversationStream } from '../../views/ConversationStream'
import { ConversationTelemetry } from '../../views/ConversationTelemetry'

export const RunConversationTurnPresenter = () => {
  const {
    data: { items, telemetry },
    states: { isStreaming },
    commands: { selectChoice },
  } = useRunConversationTurnPresenter()

  return (
    <>
      <ConversationStream
        items={items}
        isStreaming={isStreaming}
        onChoiceSelect={selectChoice}
      />
      {!IS_PROD && <ConversationTelemetry events={telemetry} />}
    </>
  )
}
